import { Component, input, ChangeDetectionStrategy } from "@angular/core";
import { TranslocoModule } from "@jsverse/transloco";
import { FilterInterface } from "src/app/core/interfaces/filter-interface";

@Component({
  selector: "app-filter-result-section",
  imports: [TranslocoModule],
  templateUrl: "./filter-result-section.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      :host {
        flex: 1;
      }
    `,
  ],
})
export class FilterResultSection {
  title = input.required<string>();
  filter = input.required<FilterInterface>();
  extraSelectedFilterTranslations = input<string[]>([]);
  filterExists = input.required<boolean>();
  textIfNoFilter = input.required<string>();

  countSelectedFilters(): number {
    const extraTranslations = this.extraSelectedFilterTranslations().filter(
      (translation) => {
        if (translation && translation.trim().length > 0) {
          return translation;
        }
      }
    );
    return (
      (!this.filter().filters ? 0 : this.filter().filters.length) +
      extraTranslations.length
    );
  }
}
